import http from "./index";

// 获取首页功能权限
export function homepage_index(data) {
  return http.fetch("/api/homepage/index", data);
}
// 获取首页文章列表
export function homepage_archivesList(data) {
  return http.fetch("/api/HomePage/archivesList", data);
}
// 获取首页广告
export function homepage_homePageAd(data) {
  return http.fetch("/api/homepage/homePageAd", data);
}
// 获取首页页脚信息
export function homepage_foot(data) {
  return http.fetch("/api/homepage/foot", data);
}
// 获取省份信息
export function getBusinessProvince(data) {
  return http.fetch("/api/basedata/getBusinessProvince", data);
}
// 广告点击记录
export function getAdsClick(data) {
  return http.fetch("/api/homepage/adsClick", data);
}
// 获取详情
export function getArchives(data) {
  return http.fetch("/api/School/archives", data);
}